import { useEffect, useState } from "react"

/** Keep access subscribers tied to displayed UI, not offscreen grid rows. Tab
 * visibility/suspend is handled separately by the session owner. */
export function useMediaVisibility() {
  const [node, ref] = useState<Element | null>(null)
  const [visible, setVisible] = useState(
    () => typeof IntersectionObserver === "undefined",
  )
  useEffect(() => {
    if (!node || typeof IntersectionObserver === "undefined") return
    const observer = new IntersectionObserver(([entry]) =>
      setVisible(entry.isIntersecting),
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [node])
  return { ref, visible: node !== null && visible }
}
